import React, { useState, useRef, useEffect } from 'react';
import { Input, Icon, Button, Grid } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { resourceActions } from '../../actions';
import HorizontalCards from '../HorizontalCards/HorizontalCards';
import Draggable from '../DnD/Draggable';
import _ from 'lodash';
import './TabPane.css';

const TabPane = props => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const resources = useSelector(state => state.resource[`${props.type.toLowerCase()}s`]);
  const hasMoreResource = useSelector(state => state.resource[`hasMore${props.type}`]);
  const status = useSelector(state => state.resource[`${props.type.toLowerCase()}Status`]);
  const imageTags = useSelector(state => state.resource[`${props.type.toLowerCase()}Tags`]);
  const selectedTemplateId = useSelector(state => state.template.templateId);
  const [closeIcon, setCloseIcon] = useState(false);
  const [showImageTags, setShowImageTags] = useState(false);
  const inputRef = useRef();
  const scrollPaneRef = useRef();
  const initRef = useRef(true);
  const returnButtonRef = useRef();
  const staticTexts = (
    <div className="textHolder">
      <Grid columns="1">
        <Grid.Row>
          <Grid.Column>
            <Draggable
              type="Text"
              data={{
                fontSize: '30',
                fontStyle: ['BOLD'],
                fontFamily: 'Vazir--ttf',
                color: '#000',
                content: `<p>${t('addHeading')}</p>`,
                width: 194,
                height: 26,
                scale: 0.1,
              }}
              onClick={() =>
                props.handleResourceClicked({
                  type: 'Text',
                  data: {
                    fontSize: '30',
                    fontStyle: ['BOLD'],
                    fontFamily: 'Vazir--ttf',
                    color: '#000',
                    content: `<p>${t('addHeading')}</p>`,
                    width: 194,
                    height: 26,
                    scale: 0.1,
                  },
                })
              }
            >
              <span
                style={{
                  fontSize: 30,
                  fontWeight: 'bold',
                  fontFamily: 'Vazir--ttf',
                }}
              >
                {t('addHeading')}
              </span>
            </Draggable>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Draggable
              type="Text"
              data={{
                fontSize: '20',
                fontFamily: 'Vazir--ttf',
                color: '#000',
                content: `<p>${t('addSubheading')}</p>`,
                width: 179,
                height: 23,
                scale: 0.1,
              }}
              onClick={() =>
                props.handleResourceClicked({
                  type: 'Text',
                  data: {
                    fontSize: '20',
                    fontFamily: 'Vazir--ttf',
                    color: '#000',
                    content: `<p>${t('addSubheading')}</p>`,
                    width: 179,
                    height: 23,
                    scale: 0.1,
                  },
                })
              }
            >
              <span style={{ fontSize: 20, fontFamily: 'Vazir--ttf' }}>{t('addSubheading')}</span>
            </Draggable>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Draggable
              type="Text"
              data={{
                fontSize: '15',
                fontFamily: 'Vazir--ttf',
                color: '#000',
                content: `<p>${t('addSimpleText')}</p>`,
                width: 134,
                height: 21,
                scale: 0.1,
              }}
              onClick={() =>
                props.handleResourceClicked({
                  type: 'Text',
                  data: {
                    fontSize: '15',
                    fontFamily: 'Vazir--ttf',
                    color: '#000',
                    content: `<p>${t('addSimpleText')}</p>`,
                    width: 134,
                    height: 21,
                    scale: 0.1,
                  },
                })
              }
            >
              <span style={{ fontSize: 15, fontFamily: 'Vazir--ttf' }}>{t('addSimpleText')}</span>
            </Draggable>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );

  useEffect(() => {
    if (props.type === 'Image') {
      setShowImageTags(true);
      dispatch(resourceActions.getImageTags());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (initRef.current) {
      initRef.current = false;
      return;
    }
    // fill until get scroll
    if (
      scrollPaneRef.current.scrollHeight - scrollPaneRef.current.clientHeight === 0 &&
      hasMoreResource &&
      status !== 'loading'
    ) {
      let query = {};
      if (_.get(inputRef, 'current.value', '').length > 0) {
        query = { q: inputRef.current.value };
      } else if (selectedTemplateId) {
        query = { tempId: selectedTemplateId };
      } else if (['Element', 'Video'].indexOf(props.type) !== -1) {
        query = { grouped: true };
      }
      props.loadMoreResource(props.type, false, query);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resources]);

  const handleSearchKeyPress = event => {
    if (event.key === 'Enter' || event.target.title === 'searchIcon') {
      if (_.isEmpty(inputRef.current.value)) {
        setShowImageTags(true);
        setCloseIcon(false);
        props.loadMoreResource(props.type, true);
      } else {
        scrollPaneRef.current.className = 'scroller-pan searched-content';
        returnButtonRef.current.ref.current.className = 'searchResetBtn active';
        setShowImageTags(false);
        props.loadMoreResource(props.type, true, { q: inputRef.current.value });
      }
    }
  };

  const handleSearchClearClicked = () => {
    scrollPaneRef.current.className = 'scroller-pan';
    returnButtonRef.current.ref.current.className = 'searchResetBtn';
    setShowImageTags(true);
    setCloseIcon(false);
    inputRef.current.value = '';
    props.loadMoreResource(props.type, true);
  };

  const searchByTag = tag => {
    scrollPaneRef.current.className = 'scroller-pan searched-content';
    returnButtonRef.current.ref.current.className = 'searchResetBtn active';
    setCloseIcon(true);
    inputRef.current.value = tag;
    props.loadMoreResource(props.type, true, { q: inputRef.current.value });
    setShowImageTags(false);
  };

  // eslint-disable-next-line no-unused-vars
  const customRenderImage = ({ index, left, top, key, photo }, type) => {
    return (
      <div key={key} className="imageTagHolder" onClick={() => searchByTag(photo.data.tags)}>
        <img alt="" className="imageTag" loading="lazy" src={photo.src} />
        <div className="tagTitle">
          <div>{t(`tags:${photo.data.tags}`)}</div>
        </div>
      </div>
    );
  };

  customRenderImage.propTypes = {
    photo: PropTypes.object,
    key: PropTypes.any,
    top: PropTypes.number,
    left: PropTypes.number,
    index: PropTypes.number,
  };

  return (
    <>
      {props.searchEnable && (
        <>
          <Input
            onChange={(event, { value }) => setCloseIcon(value ? true : false)}
            onKeyPress={handleSearchKeyPress}
            icon
            fluid
            // size="large"
            className="searchBox"
            placeholder={t('search')}
          >
            <Icon
              title="searchIcon"
              name="search"
              link
              style={{ right: 'auto', left: '1px' }}
              onClick={handleSearchKeyPress}
            />
            <input ref={inputRef} style={{ paddingLeft: '2.6em', paddingRight: '1em' }} />
            {closeIcon && <Icon name="remove" link onClick={handleSearchClearClicked} />}
          </Input>
          <Button
            ref={returnButtonRef}
            onClick={handleSearchClearClicked}
            className="searchResetBtn"
            content={t('goBack')}
          />
        </>
      )}
      <div ref={scrollPaneRef} className="scroller-pan">
        {showImageTags && _.get(imageTags, 'length', 0) > 0 && (
          <HorizontalCards
            key={1}
            className="horizontalScroll"
            parent="VSidebar"
            items={imageTags}
            itemType={'Image'}
            customImage={customRenderImage}
            height={40}
            arrowLeft={
              <div className="_arrow right-arrow">
                <Icon name="angle right" />
              </div>
            }
            arrowRight={
              <div className="_arrow left-arrow">
                <Icon name="angle left" />
              </div>
            }
          />
        )}
        {props.type === 'Text' && staticTexts}
        {props.customInfiniteScroller({
          hasMore: hasMoreResource,
          type: props.type,
          photos: resources,
          searchByTag,
          scrollParentRef: scrollPaneRef,
          searchInputRef: inputRef,
          loading: status,
          showNotFound:props.type !== 'Text'
        })}
      </div>
    </>
  );
};

TabPane.propTypes = {
  type: PropTypes.string,
  userId: PropTypes.string,
  searchEnable: PropTypes.bool,
  loadMoreResource: PropTypes.func,
  handleResourceClicked: PropTypes.func,
  customInfiniteScroller: PropTypes.func,
};

export default TabPane;
